window["wait"] = function(millis) {
  return new Promise(resolve => {
    setTimeout(resolve, millis);
  });
}

let spinnerStack = 0;
let TIMEOUT_DELAY = 20; //seconds
let timeout;
window["showSpinner"] = function() {
  console.log("");
  if (spinnerStack == 0) {
    document.getElementById("spinner").classList.add("show");
  }
  spinnerStack++;
  timeout = setTimeout(() => {
    if (spinnerStack > 0) {
      document.getElementById("spinnerClose").classList.add("show");
    }
  }, 1000 * TIMEOUT_DELAY);
}
window["hideSpinner"] = function() {
  console.log("");
  spinnerStack--;
  clearTimeout(timeout);
  if (spinnerStack == 0) {
    document.getElementById("spinner").classList.remove("show");
    document.getElementById("spinnerClose").classList.remove("show");
  }
}

window["showConfirmation"] = function(title, text, confirmText, cancelText) {
  return new Promise(resolve => {
    document.querySelector("#modalConfirmation .modal-header").innerHTML = title;
    document.querySelector("#modalConfirmation .modal-body .content").innerHTML = text;
    let btnYes = /** @type {HTMLElement} */ (document.querySelector("#modalConfirmation .modal-yes"));
    let btnNo = /** @type {HTMLElement} */ (document.querySelector("#modalConfirmation .modal-no"));
    btnYes.innerHTML = confirmText || translate('yes');
    btnNo.innerHTML = cancelText || translate('no');
    btnYes.onclick = function() {
      resolve(true);
      document.getElementById("modalConfirmation").classList.remove("show");
    };
    btnNo.onclick = function() {
      resolve(false);
      document.getElementById("modalConfirmation").classList.remove("show");
    };
    document.getElementById("modalConfirmation").classList.add("show");
  });
};

window["showAffirmation"] = function(title, text, buttonText) {
  return new Promise(resolve => {
    document.querySelector("#modalAffirmation .modal-header").innerHTML = title;
    document.querySelector("#modalAffirmation .modal-body .content").innerHTML = text;
    let btnOk = /** @type {HTMLElement} */ (document.querySelector("#modalAffirmation .modal-ok"));
    btnOk.innerHTML = buttonText || translate('ok');
    btnOk.onclick = function() {
      resolve();
      document.getElementById("modalAffirmation").classList.remove("show");
    };
    document.getElementById("modalAffirmation").classList.add("show");
  });
};

window["leftPad"] = function(str, length, pad = " ") {
  return pad.repeat(Math.max(0, length - String(str).length)) + String(str);
};

window.MAX_FILE_SIZE = 2097152;
